export const order = 9;
export const routes = {
  path: "/process",
  name: "ProcessManagement",
  component: () => import("@/views/layout"),
  meta: {
    title: "流程管理",
    guard: {
      role: ["Admin"],
      permission: ["upms:process"],
    },
  },
  children: [
    {
      path: "design",
      name: "ProcessDesign",
      meta: {
        title: "流程",
        icon: "ri-flow-chart",
        guard: {
          permission: ["upms:process:design"],
        },
      },
      children: [],
    },
    {
      path: "system",
      name: "ProcessSystemDesign",
      meta: {
        title: "系统流程",
        icon: "ri-function-fill",
        guard: {
          permission: ["upms:process:sys"],
        },
      },
      children: [],
    },
    {
      path: "form",
      name: "ProcessFormDesign",
      meta: {
        title: "表单",
        icon: "ri-todo-fill",
        guard: {
          permission: ["upms:process:form"],
        },
      },
      children: [],
    },
    {
      path: "questionnaire",
      name: "ProcessQuestionnaireDesign",
      meta: {
        title: "问卷",
        icon: "ri-survey-fill",
        guard: {
          permission: ["upms:process:questionnaire"],
        },
      },
      children: [],
    },
    {
      path: "setting",
      name: "ProcessSetting",
      meta: {
        title: "配置",
        icon: "ri-settings-6-fill",
        guard: {
          permission: ["upms:process:setting"],
        },
      },
      children: [
        {
          path: "modeling",
          name: "ProcessDataModeling",
          component: () => import("@/views/process/setting/modeling"),
          meta: {
            title: "业务表管理",
            guard: {
              role: ["Admin"],
              permission: ["upms:process:setting:modeling"],
            },
          },
        },
        {
          path: "dict",
          name: "ProcessDataDict",
          component: () => import("@/views/process/setting/dict"),
          meta: {
            title: "字典管理",
            guard: {
              role: ["Admin"],
              permission: ["upms:process:setting:dict"],
            },
          },
        },
        {
          path: "interface",
          name: "ProcessDataInterface",
          component: () => import("@/views/process/setting/interface"),
          meta: {
            title: "接口管理",
            guard: {
              role: ["Admin"],
              permission: ["upms:process:setting:interface"],
            },
          },
        },
        {
          path: "region",
          name: "ProcessDataDistrict",
          component: () => import("@/views/process/setting/district"),
          meta: {
            title: "地区管理",
            guard: {
              permission: ["upms:process:setting:district"],
            },
          },
        },
      ],
    },
  ],
};
export const perms = {
  ProcessDataDict: [
    {
      title: "新增字典",
      permission: "upms:process:setting:dict:add",
    },
    { title: "删除", permission: "upms:process:setting:dict:del" },
    { title: "修改", permission: "upms:process:setting:dict:edit" },
  ],
  ProcessDataModeling: [
    { title: "新增业务表", permission: "upms:process:setting:modeling:add" },
    { title: "删除", permission: "upms:process:setting:modeling:del" },
    { title: "修改", permission: "upms:process:setting:modeling:edit" },
  ],
  ProcessDataInterface: [
    { title: "新增接口", permission: "upms:process:setting:interface:add" },
    { title: "删除", permission: "upms:process:setting:interface:del" },
    { title: "修改", permission: "upms:process:setting:interface:edit" },
  ],
  ProcessDataRegion: [
    { title: "新增地区", permission: "upms:process:setting:district:add" },
    { title: "删除", permission: "upms:process:setting:district:del" },
    { title: "修改", permission: "upms:process:setting:district:edit" },
  ],
};
